import { assert } from "../asserts/index.ts";
import type { DesignerNodeData } from "../schemas/index.ts";
import {
  findParentlessNodeId,
  getDesignerNodeDataByIdCreate,
  getNodeSlotIdCreate,
  getPlaceholderDataCreate,
  getPlaceholderDataForIdCreate,
  getPlaceholderIdCreate,
  getTriggerDesignsSelector,
  type NodeDesignsState,
} from "../state/index.ts";
import { buildSlotPathByIdLookup } from "./buildSlotPathByIdLookup.ts";
import { getPortableDesignerNodeCreate } from "./getPortableDesignerNode.ts";
import {
  getPortableDesignerNodeInContextCreate,
  type GetPortableDesignerNodeInContext,
} from "./getPortableNodeDesignerInContext.ts";
import { getPortableNodeLinkagesCreate } from "./getPortableNodeLinkages.ts";

interface Options {
  state: NodeDesignsState;
  getCurrentNodeVersion: (node: Pick<DesignerNodeData, "typeId">) => string;
  origin: string;
  getNodeTitleById: (id: number) => string;
}

// TODO: this whole thing should be selectors. currently it is being run far too often
export const exportDesignerNodeCreate = ({
  state,
  getCurrentNodeVersion,
  origin,
  getNodeTitleById,
}: Options): GetPortableDesignerNodeInContext => {
  const getByIdData = getDesignerNodeDataByIdCreate(state);
  const rootNodeId = findParentlessNodeId(state);
  assert(rootNodeId);
  const getSlotIdById = getNodeSlotIdCreate(state);
  const getPlaceholder = getPlaceholderDataCreate(getPlaceholderIdCreate(state), getByIdData);
  const getPlaceholderForId = getPlaceholderDataForIdCreate(getSlotIdById, getPlaceholder);
  const getPortableDesignerNode = getPortableDesignerNodeCreate({
    getVersion: getCurrentNodeVersion,
    getPlaceholder: getPlaceholderForId,
    getTriggerDesigns: getTriggerDesignsSelector({ nodeDesigns: state }),
  });
  const getPortableNodeLinkages = getPortableNodeLinkagesCreate({
    getPortableDesignerNode,
    getById: getByIdData,
    nodeSlotPathByIdMap: buildSlotPathByIdLookup(getByIdData(rootNodeId)),
    getNodeTitleById,
  });
  return getPortableDesignerNodeInContextCreate({
    getPortableDesignerNode,
    getPortableNodeLinkages,
    origin,
  });
};
